import {Component, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MessageToastService} from "../../../../service/message-toast.service";
import {AccountService} from "../../../../service/api/account.service";
import {ErrorMessageEnum} from "../../../../shared/enums/error-message.enum";
import {finalize, tap} from "rxjs";
import {ApiResponse} from "../../../../shared/model/response/ApiResponse";
import {AuthenticationService} from "../../../../service/authentication-service";

@Component({
    selector: 'app-edit-password',
    templateUrl: './edit-password.component.html',
    standalone: false
})
export class EditPasswordComponent implements OnInit {

  form: FormGroup;
  formErrors: Map<string, string> = new Map();
  isLoading = false;

  constructor(
    private accountService: AccountService,
    private authTokenService: AuthenticationService,
    private toastService: MessageToastService
  ) {
  }

  ngOnInit(): void {
    this.initForm()
  }

  initForm(): void {
    this.form = new FormGroup({
      "current": new FormControl(null, Validators.required),
      "password": new FormControl(null, Validators.required),
      "passwordRepeat": new FormControl(null, Validators.required),
    });

  }

  onSubmit() {
    this.formErrors.clear()
    this.form.invalid ? this.displayFrontEndErrors() : this.changePasswordRequest()
  }

  changePasswordRequest() {
    this.isLoading = true
    this.accountService.changePassword(this.form.value)
      .pipe(
        finalize(() => this.isLoading = false),
        tap({
            next: (response) => {
              this.form.reset()
              this.authTokenService.setSession(response.data?.accessToken)
              this.toastService.success(response.message)

            },
            error: (err: ApiResponse<any>) => {
              this.formErrors = err?.formErrors ?? new Map()
              this.toastService.error(err.message)
            }
          }
        )
      )
      .subscribe()
  }

  private displayFrontEndErrors() {

    //required
    this.validateRequired('current')
    this.validateRequired('password')
    this.validateRequired('passwordRepeat')

    //password mismatch
    if (this.form.get('password') !== this.form.get('passwordRepeat')) {
      this.formErrors.set('password', ErrorMessageEnum.passwordMismatch)
      this.formErrors.set('passwordRepeat', ErrorMessageEnum.passwordMismatch)
    }

  }

  private validateRequired(field: string) {
    if (this.form.get(field)?.hasError("required")) {
      this.formErrors.set(field, ErrorMessageEnum.requiredField)
    }
  }
}
